import React, { useState } from 'react'
import Label from 'core/components/label/Label';
import styled from "styled-components";
import TypographyView from 'common/views/typographyView/Typography.view';
import { TextInputView } from 'common/views/textInput/TextInput.view';
import getAllCountryNames from "./utils/countryName";
import { DropdownSelectView } from 'common/views/dropdownSelect/DropdownSelect.view';
import { MenuItem } from '@blueprintjs/core';
import { ButtonView } from 'common/views/button/Button.view';
import { BlockView } from 'common/views/block/BlockView.view';
import { BoxView } from 'common/views/box/Box.view';

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 65%;
		flex-flow: column wrap;
		& > input {
			height:40px;
		}
	}
`;

const ShippableCartCheckoutDetailsForm = (props) => {
    const [userDetails, setUserDetails] = useState(props.shippableUserDetails || {
        name: "",
        address_one: "",
        address_two: "",
        state: "",
        city: "",
        zipCode: "",
        country: "United States",
        errorMessage: "",
        allCountryOptions: getAllCountryNames()
    });

    const { name, address_one, address_two, city, state, zipCode, country, allCountryOptions } = userDetails;
    const handleChange = (name: string, value?: string) => {
        setUserDetails({
            ...userDetails,
            [name]: value,
        });
    };

    const isFormValid = () => {
        const requiredFields = [
            city, country, address_one,
            name, state, zipCode
        ];
        return requiredFields.every(field => field);
    }

    return (
                <React.Fragment>
                    <BoxView viewKey='userDetails-form'>
                        <TypographyView viewKey="field.required" >
                            <Label k={"user.required.filled"} v={"*All fields are required*"} />
                        </TypographyView>
                        <TypographyView viewKey="user.shipping.information" >
                            <Label k={"shipping.information"} v={"Shipping Information"} />
                        </TypographyView>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.name"
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(value: string) => handleChange("name", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.address.one"
                                type="text"
                                placeholder="Address(1)"
                                value={address_one}
                                onChange={(value: string) => handleChange("address_one", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.address.two"
                                type="text"
                                placeholder="Address(2)"
                                value={address_two}
                                onChange={(value: string) => handleChange("address_two", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.state"
                                type="text"
                                placeholder="State/Province"
                                value={state}
                                onChange={(value: string) => handleChange("state", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.city"
                                type="texgt"
                                placeholder="City"
                                value={city}
                                onChange={(value: string) => handleChange("city", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.zipCode"
                                type="text"
                                placeholder="Zip/Postal Code"
                                value={zipCode}
                                onChange={(value: string) => handleChange("zipCode", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <DropdownSelectView
                                viewKey="countries"
                        items={allCountryOptions}
                                popOverContentStyles={{
                                    maxHeight: "200px",
                                    overflowY: "scroll"
                                }}
                                itemRenderer={(value: any, { handleSelect }) => {
                                    return (
                                        <MenuItem
                                            key={value}
                                            text={<Label k={value} v={value} args={{ value }} />}
                                            onClick={handleSelect}
                                        />
                                    );
                                }}
                                onChange={(value: string) => handleChange("country", value)}
                            >
                                <Label k="Country" v={userDetails.country || "United States"} args={{ value: userDetails.country }} />
                            </DropdownSelectView>
                        </StyledDiv>
                {isFormValid() ? (
                            <BlockView viewKey={"cart.summary.continue"}>
                                <ButtonView viewKey={"cart-continue"} onClick={() => {
                                    props.handleContinueClick();
                                    //props.saveShippingInfo(userDetails);
                                    props.actions.saveShippableUserDetails(userDetails)
                                }}
                                >Continue</ButtonView>
                            </BlockView>
                        ) : ""}
            </BoxView>
        </React.Fragment>
    )
}

export default ShippableCartCheckoutDetailsForm;




// WEBPACK FOOTER //
// ./src/panels/catalog/cart/ShippableCheckOutDetails.tsx